import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { en } from '@/i18n/locales/en';
import { ptBR } from '@/i18n/locales/pt-BR';

const resources = {
  'pt-BR': { translation: ptBR },
  en: { translation: en },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'pt-BR',
  fallbackLng: 'pt-BR',
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
export { ptBR, en };
